import { render, staticRenderFns } from "./WebReportPFA.vue?vue&type=template&id=60a1843d&scoped=true&lang=pug&"
import script from "./WebReportPFA.vue?vue&type=script&lang=ts&"
export * from "./WebReportPFA.vue?vue&type=script&lang=ts&"
import style0 from "./WebReportPFA.vue?vue&type=style&index=0&id=60a1843d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a1843d",
  null
  
)

export default component.exports